// src/vocabulary/B2/unit3/content.js

const content = {
  level: "B2",
  unit: 3,
  title: "Travel Problems & Solutions",
  description:
    "Common travel problems and how to talk about solutions. Learn how to explain issues and ask for help while traveling.",

  explanation: [
    "This unit focuses on problems that can happen during travel.",
    "You will learn words to describe delays, lost items, and cancellations.",
    "These words are often used at airports, hotels, and stations.",
    "People use this vocabulary to explain a problem and ask for a solution.",
    "For example: My flight was delayed. My luggage is lost.",
    "You can also use polite language to ask for help.",
    "Being able to explain problems clearly is an important B2 skill.",
    "Try to describe a travel problem and how you would solve it."
  ],

  items: [
    {
      word: "delay",
      phonetic: "/dɪˈleɪ/",
      meaning: "تأخير",
      example: "The flight was delayed for two hours."
    },
    {
      word: "cancelled",
      phonetic: "/ˈkænsəld/",
      meaning: "ملغى",
      example: "The train was cancelled."
    },
    {
      word: "lost luggage",
      phonetic: "/lɒst ˈlʌɡɪdʒ/",
      meaning: "أمتعة مفقودة",
      example: "My luggage is lost."
    },
    {
      word: "problem",
      phonetic: "/ˈprɒbləm/",
      meaning: "مشكلة",
      example: "We had a problem at the airport."
    },
    {
      word: "solution",
      phonetic: "/səˈluːʃn/",
      meaning: "حل",
      example: "They offered a solution."
    },
    {
      word: "refund",
      phonetic: "/ˈriːfʌnd/",
      meaning: "استرداد أموال",
      example: "I asked for a refund."
    },
    {
      word: "complain",
      phonetic: "/kəmˈpleɪn/",
      meaning: "يشتكي",
      example: "He complained about the service."
    }
  ]
};

export default content;


